import { Component, Input } from '@angular/core';
import { ErrorMsgModal } from './error-msg-modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'error-msg-modal',
	template: require('./error-msg-modal.component.html'),
})
export class ErrorMsgModalComponent {
	//input that determines the type of error
	//by default is general error
	@Input() errorType: string = 'business-error-msg';
	@Input() icon: string;
	@Input() errorMessage: string =
		'Παρουσιάστηκε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με το +30 210 4848484.';
	@Input() title: string;
	@Input() message: string;
	@Input() message2: string;
	@Input() input: string = '';
	@Input() action: string = '';

	constructor(private activeModalService: NgbActiveModal) {}
	errorMsgModal: ErrorMsgModal;
	public isNewErrorModal: boolean = AppSettings.isNewErrorModalEnabled;
	public isRebrading = AppSettings.isRebrading;

	errorMsgModalGeneral: ErrorMsgModal = {
		type: 'general-error-msg',
		icon: 'general-error-msg',
		isRefresh: false,
	};

	errorMsgModalBusiness: ErrorMsgModal = {
		type: 'business-error-msg',
		icon: 'business-error-msg',
		iconSize: 'small',
		iconShape: 'square',
		isRefresh: false,
	};

	errorMsgModalConnectivity: ErrorMsgModal = {
		type: 'connectivity-error-msg',
		icon: 'connectivity-error-msg',
		iconSize: 'small',
		iconShape: 'square',
		isRefresh: true,
	};

	public get iconSize(): string {
		if (!!this.errorMsgModal.iconSize) {
			return 'error-modal-responsive-image-figure--' + this.errorMsgModal.iconSize;
		} else {
			return 'error-modal-responsive-image-figure';
		}
	}

	public get iconShape(): string {
		if (!!this.errorMsgModal.iconShape) {
			return 'error-modal-responsive-img-container--' + this.errorMsgModal.iconShape;
		} else {
			return 'error-modal-responsive-img-container';
		}
	}

	public get iconSrc(): string {
		return './Content/icons/' + this.errorMsgModal.icon + '.svg';
	}

	public get resolvedIconSrc(): string {
		if (this.icon) {
			return './Content/images/login-error-modal/' + this.icon + '.svg';
		}
		return this.iconSrc;
	}

	public get resolvedActionLabel(): string {
		if (this.action) {
			return this.action;
		}
		return this.errorMsgModal && this.errorMsgModal.isRefresh
			? 'Ανανέωση'
			: 'Οκ, το κατάλαβα';
	}

	ngOnInit() {
		switch (this.errorType) {
			case 'business-error-msg':
				this.errorMsgModal = this.errorMsgModalBusiness;
				if (!!this.icon) {
					this.errorMsgModal.icon = this.icon;
				}
				break;
			case 'connectivity-error-msg':
				this.errorMsgModal = this.errorMsgModalConnectivity;
				break;
			default:
				this.errorMsgModal = this.errorMsgModalGeneral;
				break;
		}
	}

	closeModal(isRefresh?: boolean) {
		if (isRefresh) {
			this.activeModalService.close();
			location.reload();
		} else {
			this.activeModalService.close();
		}
	}
}
